__turbopack_context__.v({
  "dark": "TestHardwareIcon-module__EjtuwG__dark",
  "light": "TestHardwareIcon-module__EjtuwG__light",
  "root": "TestHardwareIcon-module__EjtuwG__root",
});
